// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-list {\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: collapse;\n}\n.table-list tr {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n    display: block;\n    cursor: pointer;\n}\n.table-list tr td {\n      padding: 2px 10px;\n      font-size: 0.75rem;\n}\n.table-list tr td div.txtoverflow {\n        text-overflow: ellipsis;\n        overflow: hidden;\n        white-space: nowrap;\n}\n@media (min-width: 992px) {\n.card-group {\n    height: 100%;\n}\n}\n", ""]);
// Exports
module.exports = exports;
